import { Component } from '@angular/core';

@Component({
  selector: 'app-policies-politics',
  templateUrl: './policies-politics.component.html',
  styleUrls: ['./policies-politics.component.css']
})
export class PoliciesPoliticsComponent {

}
